module.exports = __webpack_public_path__ + "img/RJMT_telephone_brown.45704f76.svg";